import { render, staticRenderFns } from "./resultDialog.vue?vue&type=template&id=08b39c4a&scoped=true"
import script from "./resultDialog.vue?vue&type=script&lang=js"
export * from "./resultDialog.vue?vue&type=script&lang=js"
import style0 from "./resultDialog.vue?vue&type=style&index=0&id=08b39c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b39c4a",
  null
  
)

export default component.exports